import { youtubeEmbed } from './youtube';

/** Video incrustado de YouTube; si no se puede incrustar, un botón para abrirlo. */
export function VideoEmbed({ url, title }: { url: string; title: string }) {
  const embed = youtubeEmbed(url);
  if (!embed) {
    return (
      <a className="btn btn--primary" href={url} target="_blank" rel="noopener noreferrer">
        Ver video
      </a>
    );
  }
  return (
    <div className="video">
      <iframe src={embed} title={title} loading="lazy" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
    </div>
  );
}
